var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticStyle:{"z-index":"10000"},attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('v-icon',{staticStyle:{"right":"-13px"},attrs:{"color":_vm.color.first,"small":""}},[_vm._v("uil uil-check")]),_c('v-icon',{attrs:{"color":_vm.color.second,"small":""}},[_vm._v("uil uil-check")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }